import { render, staticRenderFns } from "./TaxReturnYearlyResico.vue?vue&type=template&id=200b8654&scoped=true"
import script from "./TaxReturnYearlyResico.vue?vue&type=script&lang=js"
export * from "./TaxReturnYearlyResico.vue?vue&type=script&lang=js"
import style0 from "./TaxReturnYearlyResico.vue?vue&type=style&index=0&id=200b8654&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200b8654",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('200b8654')) {
      api.createRecord('200b8654', component.options)
    } else {
      api.reload('200b8654', component.options)
    }
    module.hot.accept("./TaxReturnYearlyResico.vue?vue&type=template&id=200b8654&scoped=true", function () {
      api.rerender('200b8654', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/components/TaxReturnYearlyResico.vue"
export default component.exports